const loginType = {
  START_LOGIN: "START_LOGIN",
  LOGIN_USER_BY_TOKEN: "LOGIN_USER_BY_TOKEN",
  SUCCESS_LOGIN: "SUCCESS_LOGIN",
  FAILURE_LOGIN: "FAILURELOGIN",
  SET_ERROR_FALSE: "SET_ERROR_FALSE",
  CHANGE_ACTIVE_STEP: "CHANGE_ACTIVE_STEP",
  SET_LOGIN_TYPE: "SET_LOGIN_TYPE",
  START_REGISTER: "START_REGISTER",
};

export default loginType;
